import { serviceCountLabel } from "../serviceRules";
import { errorStyle, serviceCountBadgeStyle } from "../superAdminStyles";
import { ServiceIndicator } from "./ServiceIndicator";
import { ServiceCreateRow, ServiceRow } from "./ServiceRows";
import { useServiceManager } from "./useServices";

const smallMutedStyle = { color: "#9ca3af", fontSize: "13px", margin: 0 };

function ServiceList({ services, serviceTypeOptionsFor, patchService }) {
    return (
        <div style={{ display: "grid", gap: "10px", marginBottom: "14px" }}>
            {services.length === 0 && <p style={smallMutedStyle}>Aucun service configuré.</p>}
            {services.map(service => (
                <ServiceRow key={service.id} service={service} typeOptions={serviceTypeOptionsFor(service)} patchService={patchService} />
            ))}
        </div>
    );
}

export function ServiceManager({ pharmacyId }) {
    const manager = useServiceManager(pharmacyId);
    const { services, loading, error } = manager;

    return (
        <div style={{ marginBottom: "14px", paddingTop: "14px", borderTop: "1px solid #e2e8f0" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "12px" }}>
                <h3 style={{ fontSize: "13px", color: "#111827", margin: 0, fontWeight: 700 }}>Services</h3>
                {!loading && <span style={serviceCountBadgeStyle}>{serviceCountLabel(services.length)}</span>}
            </div>
            {!loading && <ServiceIndicator pharmacyId={pharmacyId} services={services} />}
            {loading ? (
                <p style={smallMutedStyle}>Chargement des services...</p>
            ) : (
                <ServiceList services={services} serviceTypeOptionsFor={manager.serviceTypeOptionsFor} patchService={manager.patchService} />
            )}
            <ServiceCreateRow
                form={manager.form}
                setForm={manager.setForm}
                saving={manager.saving}
                typeOptions={manager.availableCreateServiceTypes}
                createService={manager.createService}
            />
            {error && <p style={errorStyle}>{error}</p>}
        </div>
    );
}
